export default "<app-inthanon-national-park></app-inthanon-national-park>\n"